<style scoped>
    @import url("../../styles/dashMain/painelPddDashMain.scss");
</style>

<template>
    <div class="box_painelPddDashMain">

        <!-- CARD DE UM PEDIDO -->
        <div class="cardPdd">

            <!-- info basica -->
            <div class="elCardPdd mb-1">
                <div class="tam1" :style="{'color':'#092D4F'}">Estado do pedido: </div>
                <div class="tam1 ml-2" v-if="liAllPdd[0]['status_payment'] == 'awaiting_payment'">Aguardando pagamento</div>
                <div class="tam1 ml-2" v-if="liAllPdd[0]['status_payment'] == 'paid'">Preparação do envio</div>
            </div>
            <div class="elCardPdd mb-1">
                <div class="tam1" :style="{'color':'#092D4F'}">Data inicial do pedido: </div>
                <div class="tam1 ml-2">{{ liAllPdd[0]['dt_str'] }}</div>
            </div>
            <div class="elCardPdd mb-1">
                <div class="tam1" :style="{'color':'#092D4F'}">Tipo do pagamento: </div>
                <div class="tam1 ml-2">{{ liAllPdd[0]['payment_method'] }}</div>
            </div>

            <!-- lista do carrinho -->
            <div class="elCardPddItems mb-1 ">

                <!-- LARGE -->
                <div class="el_itemPdd_tit mb-1 hidden-sm-and-down">
                    <div class="itemEnd mr-1" :style="{'min-width':'100px'}">ID Produto</div>
                    <div class="itemEnd mr-1" :style="{'min-width':'180px'}">Categoria</div>
                    <div class="itemEnd mr-1" :style="{'min-width':'220px'}">Nome</div>
                    <div class="itemEnd mr-1" :style="{'min-width':'100px'}">Preço unit.</div>
                    <div class="itemEnd mr-1" :style="{'min-width':'50px'}">Quant.</div>
                    <div class="itemEnd" :style="{'min-width':'50px','margin-left':'auto'}">Total</div>
                </div>

                <div class="el_itemPdd mb-1 hidden-sm-and-down" v-for="(item,i) in liAllPdd[0]['items']" :key="i">
                    <div class="itemEnd mr-1" :style="{'min-width':'100px'}">{{ item.product_id }}</div>
                    <div class="itemEnd mr-1" :style="{'min-width':'180px'}">{{ item.sku }}</div>
                    <div class="itemEnd mr-1" :style="{'min-width':'220px'}">{{ item.name }}</div>
                    <div class="itemEnd mr-1" :style="{'min-width':'100px'}">{{ item.unit_price }}</div>
                    <div class="itemEnd mr-1" :style="{'min-width':'50px'}">{{ item.quantity }}</div>
                    <div class="itemEnd" :style="{'min-width':'50px','margin-left':'auto'}">{{ item.line_total }}</div>
                </div>

                <!-- SMALL -->
                <div class="el_itemPdd_tit mb-1 hidden-md-and-up">
                    <div class="itemEnd mr-1" :style="{'min-width':'200px'}">ID Produto</div>
                    <div class="itemEnd mr-1" :style="{'min-width':'200px'}">Categoria</div>
                    <div class="itemEnd mr-1" :style="{'min-width':'200px'}">Nome</div>
                    <div class="itemEnd mr-1" :style="{'min-width':'200px'}">Preço unit.</div>
                    <div class="itemEnd mr-1" :style="{'min-width':'200px'}">Quant.</div>
                    <div class="itemEnd" :style="{'min-width':'50px'}">Total</div>
                </div>

                <div class="el_itemPdd mb-1 hidden-md-and-up" v-for="(item,i) in liAllPdd[0]['items']" :key="i">
                    <div class="itemEnd mr-1" :style="{'min-width':'200px'}">{{ item.product_id }}</div>
                    <div class="itemEnd mr-1" :style="{'min-width':'200px'}">{{ item.sku }}</div>
                    <div class="itemEnd mr-1" :style="{'min-width':'200px'}">{{ item.name }}</div>
                    <div class="itemEnd mr-1" :style="{'min-width':'200px'}">{{ item.unit_price }}</div>
                    <div class="itemEnd mr-1" :style="{'min-width':'200px'}">{{ item.quantity }}</div>
                    <div class="itemEnd" :style="{'min-width':'50px'}">{{ item.line_total }}</div>
                </div>
            </div>

            <!-- resumo do custo do carrinho -->
            <div class="summary mb-1">
                <div class="summaryTit ml-1">
                    <div>Transporte</div>
                    <div>Subtotal</div>
                    <div>Tax (23%)</div>
                    <div>Total</div>
                </div>
                <div class="summaryC mr-1">
                    <div>{{ Number(liAllPdd[0].summary.shipping).toFixed(2) }}</div>
                    <div>{{ Number(liAllPdd[0].summary.subtotal).toFixed(2) }}</div>
                    <div>{{ Number(liAllPdd[0].summary.tax).toFixed(2) }}</div>
                    <div>{{ (Math.ceil(liAllPdd[0].summary.total * 100) / 100).toFixed(2) }}</div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
export default {

    props:['liAllPdd'],

    //components:{LoginPageTipoA, PainelDashMain},

    data() {
        return {
            //
        }
    },

    methods:{
        //
    },

    created() {
        console.log('this.liAllPdd: ',this.liAllPdd)
    }
}
</script>